import React from 'react'

import { styled } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import imgs from './images'

const Bet = styled(Avatar)({
  width: 50,
  height: 50,
})

const BetIcons = Object.fromEntries(
  Object
    .entries(imgs)
    .map(([amount, imgSet]) => [amount, {
      default: <Bet src={imgSet.default} />,
      disabled: <Bet src={imgSet.disabled} />,
      active: <Bet src={imgSet.active} />,
    }])
)

/* ASC sorted amounts: '10' | '50' | '100' | '500' | '1000' | '3000' */
export const BET_BUTTON_AMOUNTS = Object.keys(imgs).sort((a, b) => Number(a) - Number(b))

export type SupportBetAmounts = typeof BET_BUTTON_AMOUNTS[number]

interface BetProps extends IconButtonProps {
  amount: SupportBetAmounts
  selected?: boolean
}
export default function Bets({ amount = BET_BUTTON_AMOUNTS[0], selected, ...props }: BetProps) {
  const state = props.disabled
    ? 'disabled'
    : selected ? 'active' : 'default'

  return (
    <IconButton {...props}>
      { BetIcons[amount][state] }
    </IconButton>
  )
}
